import React, {Component} from "react"
import Confetti from 'react-confetti'
import celebrationStyles from "./celebration.module.css"

class Celebration extends Component {
    constructor(props) {
        super(props);

        this.state = {
            confettiCount: 0,
            confettiText: "I'm just here for the confetti.",
            height: 0, 
            width: 0
        }
    }

    componentDidMount() {
        this.setState({
            height: window.innerHeight,
            width: window.innerWidth
        })
    }

    render() {
        
        return (
            <div style={{maxWidth: '100%'}}>
                <Confetti
                    width={this.state.width}
                    height={this.state.height}
                    colors={["#ab3281", "#f9b503", "#E31C23", "#00b4ba"]}
                    initialVelocityX={10}
                    initialVelocityY={19}
                    numberOfPieces={String(this.state.confettiCount)}
                />
                <a href="/celebrate/aapi-heritage" style={{textDecoration: 'none', color: 'black'}}>
                    <div className={celebrationStyles.banner}>
                        <h4 className={celebrationStyles.desktopBannerText}>Happy AAPI Heritage Month! Click to Learn More.</h4>
                        <h4 className={celebrationStyles.mobileBannerText}>Happy AAPI Heritage Month! Tap to Learn More.</h4>
                        <div 
                            className={celebrationStyles.confettiSwitch}
                            onClick={(event) => {
                                event.preventDefault(); 
                                this.setState({confettiCount:800}, () => setTimeout(() => this.setState({confettiCount: 0}), 1500))
                            }}
                        >
                            🎉
                        </div>
                    </div>
                </a>
                
            </div>
        )
    }
}

export default Celebration;